import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kode Penumpang", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Jenis Penumpang", -1)
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Keterangan", -1)
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "IsShow",
  class: "ml-2"
}, " Tampilkan pada kondektur ", -1)
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_14 = { class: "container-btn-action" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import Checkbox from 'primevue/checkbox'
import { onMounted, getCurrentInstance, ref, reactive, computed } from 'vue'
import { IBankForm } from '@/utils/interfaces/iBank'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const dataForm = ref()
const titleButton = ref('Simpan Jenis Penumpang')
const isUpdate = ref(false)

const moduleStore = 'hjpDataList'
const endpoint = '/management/v1/MsPassenger'

const modalForm = computed(() => store.state[moduleStore].modalForm) as any

const initialValues = {
  Type: modalForm.value.data ? modalForm.value.data.Type : null,
  Code: modalForm.value.data ? modalForm.value.data.Code : null,
  IsActive: modalForm.value.data ? modalForm.value.data.IsActive : true,
  IsShow: modalForm.value.data ? modalForm.value.data.IsShow : false,
  Description: modalForm.value.data ? modalForm.value.data.Description : ''
}

const schema = Yup.object().shape({
  Type: Yup.string()
    .required('Nama Jenis Penumpang harus diisi!')
    .max(30, 'Nama Jenis Penumpang maksimal 30 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Jenis Penumpang tidak boleh hanya menggunakan spasi')
    .test('unique-type', 'Nama Jenis Penumpang sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['type']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Type === val)
        if (modalForm.value?.data?.Id) {
          return filterResult.length === 0 || val === initialValues.Type
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Code: Yup.string()
    .required('Kode Penumpang harus diisi!')
    .max(4, 'Kode Penumpang maksimal 4 karakter')
    .matches(rgxExp.notSpaceChar, 'Kode Penumpang tidak boleh menggunakan spasi')
    .test('unique-code', 'Kode Penumpang sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['code']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Code === val)
        if (modalForm.value?.data?.Id) {
          return filterResult.length === 0 || val === initialValues.Code
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
})

const attrModalConfirmation = reactive({
  show: false,
  title: '',
  subTitle: '',
  btnSubmitTitle: '',
  imgContent: require('@/assets/img/modal-confirmation/passenger-add-update.svg')
})

const checkAddOrUpdate = () => {
  if (modalForm.value.data) {
    attrModalConfirmation.title = 'Simpan Perubahan Jenis Penumpang?'
    attrModalConfirmation.subTitle = 'Pastikan data data jenis penumpang sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
    isUpdate.value = true
  } else {
    attrModalConfirmation.title = 'Simpan Jenis Penumpang '
    attrModalConfirmation.subTitle = 'Pastikan data data jenis penumpang sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
  }
}

const onSubmit = (val: any) => {
  dataForm.value = {
    Type: val.Type,
    Code: val.Code.toUpperCase(),
    IsShow: val.IsShow,
    IsActive: val.IsActive,
    IsDelete: false,
    Description: val.Description
  }
  attrModalConfirmation.show = true
}

const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSubmitConfirmation = async () => {
  const toastMessage = isUpdate.value ? 'Berhasil mengubah Jenis Penumpang' : 'Berhasil menambahkan Jenis Penumpang'
  const toastDetailMesssage = isUpdate.value ? 'Jenis penumpang sudah diubah dan dapat digunakan pada fitur lain.' : 'Jenis penumpang sudah ditambahkan dan dapat digunakan pada fitur lain.'
  const response = !isUpdate.value ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, modalForm.value.data.Id, dataForm.value)
  if (!response.error) {
    store.dispatch('setShowModalFormDl', false)
    store.dispatch('setReloadDataList')
    $toast.add({
      severity: 'success',
      summary: toastMessage,
      detail: toastDetailMesssage,
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    // store.dispatch('setShowModal', false)
    $toast.add({
      severity: 'error',
      detail: response.message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  // eslint-disable-next-line no-use-before-define
  hideDialogConfirmation()
  hideSidebar()
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
}

const test = (val: any) => {
  console.log('val', val)
}

onMounted(() => {
  let titleForm = 'Tambah'
  if (modalForm.value.data) {
    titleForm = 'Edit'
    titleButton.value = 'Simpan perubahan'
  }
  store.dispatch('setTitleFormSidebarDl', `${titleForm} Jenis Penumpang`)
  checkAddOrUpdate()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Field), { name: "Code" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Code,
                "onUpdate:modelValue": ($event: any) => ((values.Code) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Code ? 'input-invalid' : ''}`,
                placeholder: "Tulis kode penumpang"
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_3, _toDisplayString(errors.Code), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Field), { name: "Type" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Type,
                "onUpdate:modelValue": ($event: any) => ((values.Type) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Type ? 'input-invalid' : ''}`,
                placeholder: "Tulis Jenis Penumpang"
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_6, _toDisplayString(errors.Type), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(Field), {
            name: "Description",
            as: "textarea",
            placeholder: "Tulis Keterangan",
            class: "input-primary"
          }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(Textarea), {
                id: "Description",
                autocomplete: "nope",
                autoResize: true,
                ref: "addressRef",
                rows: "3",
                onChange: handleChange,
                onBlur: handleBlur
              }, null, 8, ["onChange", "onBlur"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(Field), { name: "IsShow" }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(Checkbox), _mergeProps(field, {
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                  binary: true,
                  inputId: "IsShow",
                  name: "IsShow",
                  onClick: ($event: any) => (test(values.IsShow))
                }), null, 16, ["modelValue", "onUpdate:modelValue", "onClick"]),
                _hoisted_11
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_unref(Field), { name: "IsActive" }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                inputId: "isactive"
              }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(HjpCofirmModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})